import React, { useEffect } from 'react';
import { useApp } from '../context/AppContext';

const ConfirmationScreen = () => {
  const { setScreen, refreshData } = useApp();

  useEffect(() => {
    const timer = setTimeout(async () => {
      await refreshData();
      setScreen('dashboard');
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl shadow-xl p-8 text-center max-w-sm">
        <div className="bg-green-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h2 className="text-2xl font-bold text-gray-800 mb-2">Success!</h2>
        <p className="text-gray-600">Transaction added successfully</p>
      </div>
    </div>
  );
};

export default ConfirmationScreen;
